// src/components/admin/AdminNav.tsx
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { collection, doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const AdminNav: React.FC = () => {
  const location = useLocation();
  const { currentUser } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  
  // Check if current user is admin
  useEffect(() => {
    const checkAdmin = async () => {
      if (!currentUser) return;
      
      // Check if email is admin
      if (currentUser.email === 'jhatcher4@ccc.edu' || currentUser.email === 'admin@example.com') {
        setIsAdmin(true);
        return;
      }
      
      // Check in users collection
      try {
        const userRef = doc(db, 'users', currentUser.uid);
        const userDoc = await getDoc(userRef);
        
        if (userDoc.exists() && userDoc.data().role === 'admin') {
          setIsAdmin(true);
        }
      } catch (err) {
        console.error("Error checking admin status:", err);
      }
    };
    
    checkAdmin();
  }, [currentUser]);
  
  // Only show for admins
  if (!isAdmin) return null;
  
  return (
    <div className="bg-indigo-700 text-white py-2 px-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="text-lg font-semibold">Admin Panel</div>
        <div className="flex space-x-4">
          <Link 
            to="/admin" 
            className={`px-3 py-2 rounded-md text-sm font-medium ${
              location.pathname === '/admin' ? 'bg-indigo-800' : 'hover:bg-indigo-600'
            }`}
          >
            Admin Dashboard
          </Link>
          <Link 
            to="/" 
            className="px-3 py-2 rounded-md text-sm font-medium hover:bg-indigo-600"
          >
            Back to App
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminNav;